import React, { useEffect, useState } from "react";
import { useConnectModal } from "@rainbow-me/rainbowkit";
import {
  useAccount,
  useBalance,
  useToken,
  useBlockNumber,
  useReadContract
} from "wagmi";
import useCustomContractRead from "../../../Hooks/useCustomContractRead";
import {
  WETHX_PTN_POOL_ADDRESS,
  WETH_TOKEN_ADDRESS,
  GUARDX_POOL_ADDRESS,
  GUARD_TOKEN_ADDRESS,
  ANDYX_POOL_ADDRESS,
  ANDY,
  ANDY_TOKEN_ADDRESS,
} from "../../../Config";
import WETHX_PTN_POOL_ABI from "../../../Config/WETHX_PTN_POOL_ABI.json";
import ApproveButton from "../../common/ApproveButton";
import useCustomContractWrite from "../../../Hooks/useCustomContractWrite";
import convertEtherToWei from "../../../Utils/convertEtherToWei";
import Loader from "../../Loader/Loader";
import convertWeiToEther from "../../../Utils/convertWeiToEther";
import useCheckAllowance from "../../../Hooks/useCheckAllowance";
import $ from "jquery";
import style from "./mint.module.css";
import { NewFooter } from "../../NewFooter";
import AddIcon from '@mui/icons-material/Add';

const Mint = () => {
  // Token selection state
  const [selectedToken, setSelectedToken] = useState("BNB");
  const [showTokenDropdown, setShowTokenDropdown] = useState(false);

  // Input states
  const [alienInputValue, setAlienInputValue] = useState("");
  const [alienXInputValue, setAlienXInputValue] = useState("");
  const [SlippageInPercent, setSlippageInPercent] = useState(0.5);
  const [isAproveERC20, setIsApprovedERC20] = useState(false);

  // Token configurations
  const TOKEN_CONFIG = {
    BNB: {
      poolAddress: WETHX_PTN_POOL_ADDRESS,
      tokenAddress: "",
      symbol: "BNB",
      xSymbol: "BNBX",
      icon: "/icons/bnb.png"
    },
    GUARD: {
      poolAddress: GUARDX_POOL_ADDRESS,
      tokenAddress: GUARD_TOKEN_ADDRESS,
      symbol: "GUARD",
      xSymbol: "GUARDX",
      icon: "/icons/guard.png"
    },
     ANDY: {
      poolAddress: ANDYX_POOL_ADDRESS,
      tokenAddress: ANDY_TOKEN_ADDRESS,
      symbol: "ANDY",
      xSymbol: "ANDYX",
      icon: "/icons/andy.png"
    }
  };

  const currentConfig = TOKEN_CONFIG[selectedToken];

  // Wagmi hooks
  const { address, isConnected } = useAccount();
  const { openConnectModal } = useConnectModal();
  const { data: currentBlock } = useBlockNumber({ watch: true });

  // Contract reads
  const { data: calcMint } = useCustomContractRead({
    Adrress: currentConfig.poolAddress,
    Abi: WETHX_PTN_POOL_ABI,
    FuncName: "calcMint",
    Args: [convertEtherToWei?.(alienInputValue === "" ? "0" : alienInputValue)],
    isEnabled: alienInputValue,
    onSuccess: (data) => {
      setAlienXInputValue(
        parseFloat?.(convertWeiToEther?.(data?.[0]?.toString()))
      );
    },
  });

  const { data: poolInfo } = useCustomContractRead({
    Adrress: currentConfig.poolAddress,
    Abi: WETHX_PTN_POOL_ABI,
    FuncName: "info",
    onSuccess: (data) => { },
  });


  const { data: xTokenAddress } = useCustomContractRead({
    Adrress: currentConfig.poolAddress,
    Abi: WETHX_PTN_POOL_ABI,
    FuncName: "xToken",
  });

    const { data: xTokenInfo } = useToken({
      address: xTokenAddress,
    });


  // Balance checks
  const { data: alienBalance } = useBalance({
    address: address,
    token: currentConfig.tokenAddress,
    watch: true,
    enabled: address !== undefined,
  });

  const { data: alienXBalance } = useBalance({
    address: address,
    token: xTokenAddress,
    watch: true,
    enabled: address !== undefined && xTokenAddress !== undefined,
  });

  // console.log(currentConfig.tokenAddress, currentConfig.poolAddress);
  
  // Allowance check
  const { data: checkAllowance } = useCheckAllowance({
    tokenAddress: currentConfig.tokenAddress,
    spenderAddress: currentConfig.poolAddress,
    isLpToken: false,
  });

  // User info
  const { data: userInfo, refetch: refetchUserInfo } = useReadContract({
    address: currentConfig.poolAddress,
    abi: WETHX_PTN_POOL_ABI,
    functionName: "userInfo",
    args: [address],
    enabled: address !== undefined,
    watch: true
  });

  // Effects
  useEffect(() => {
    if (checkAllowance && address) {
      const price = parseFloat?.(alienInputValue === "" ? "1" : alienInputValue);
      const allowance = parseFloat?.(convertWeiToEther?.(checkAllowance));
      setIsApprovedERC20(allowance >= price);
    }
  }, [checkAllowance, address, alienInputValue]);

  useEffect(() => {
    refetchUserInfo();
  }, [currentBlock]);

  // Handlers
  const stackhandleAlienInputChange = (event, mintingFee) => {
    const { value } = event.target;
    const isStack = /^[0-9]*(\.[0-9]{0,18})?$/.test(value);
    if (isStack) {
      try {
        setAlienInputValue(value);
        const valueAfterFeeCut = value !== ""
          ? (parseFloat?.(value) - parseFloat?.(value) * (mintingFee / 100)).toFixed(4)
          : "0.0";
        setAlienXInputValue(valueAfterFeeCut);
      } catch (e) { }
    }
  };

  const setMax = (value, mintingFee) => {
    const isStack = /^[0-9]*(\.[0-9]{0,18})?$/.test(value);
    if (isStack) {
      setAlienInputValue(value);
      const valueAfterFeeCut = value !== ""
        ? (parseFloat?.(value) - parseFloat?.(value) * (mintingFee / 100)).toFixed(4)
        : "0.0";
      // const valueAfterFeeCut = parseFloat?.(value)    
      setAlienXInputValue(valueAfterFeeCut);
    }
  };

  const handleTokenSelect = (token) => {
    setSelectedToken(token);
    setShowTokenDropdown(false);
    setAlienInputValue("");
    setAlienXInputValue("");
  };

  // Contract writes
  const {
    executeWrite: executeWriteMint,
    isLoading: isLoadingMint,
  } = useCustomContractWrite({
    address: currentConfig.poolAddress,
    abi: WETHX_PTN_POOL_ABI,
    functionName: "mint",
    args: [
      convertEtherToWei?.(
        alienInputValue !== ""
          ? (parseFloat?.(alienXInputValue) - parseFloat?.(alienXInputValue) * (SlippageInPercent / 100)).toString()
          : "0.0"
      ),
      convertEtherToWei?.(alienInputValue === "" ? "0" : alienInputValue),
    ],
    isEnabled:

      parseFloat?.(alienInputValue === "" ? "0" : alienInputValue) > 0 &&
      parseFloat?.(alienInputValue === "" ? "0" : alienInputValue) <=
      parseFloat?.(alienBalance?.formatted) &&
      address !== undefined &&
      !poolInfo?.[4] &&
      isAproveERC20,
    value: selectedToken === "BNB" ? convertEtherToWei?.(alienInputValue === "" ? "0" : alienInputValue) : undefined,
  });


  const {
    executeWrite: executeWriteCollect,
    isLoading: isLoadingCollect,
  } = useCustomContractWrite({
    abi: WETHX_PTN_POOL_ABI,
    address: currentConfig.poolAddress,
    functionName: "collect",
  });

  const handleMint = async () => {
    try {
      await executeWriteMint();
      refetchUserInfo();
      setAlienInputValue(0);
    } catch (error) {
      console.error("Mint error:", error);
    }
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = () => {
      if (showTokenDropdown) {
        setShowTokenDropdown(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [showTokenDropdown]);
  

  const addTokenInMetaMask = (tokenSymbol, tokenAddress, tokenIcon) => {
    window.ethereum
      .request({
        method: "wallet_watchAsset",
        params: {
          type: "ERC20",
          options: {
            address: tokenAddress,
            symbol: tokenSymbol,
            decimals: 18,
            image: tokenIcon,
          },
        },
      })
      .then((success) => {
        if (success) {
          //console.log("FOO successfully added to wallet!");
        } else {
          throw new Error("Something went wrong.");
        }
      })
      .catch(console.error);
  };


  return (
    <main className={style.mint + " pt-sm-5 pb-0 py-0"}>
      <div className="d-flex justify-content-center align-items-start">
        <div className={style.container}>
          <div className="mb-5 align-items-center mt-2 d-flex justify-content-between">
            <h1 className='text-center px-3'>Mint Now</h1>
            <div className="tooltip-parent position-relative coursor-pointer" style={{ cursor: "pointer" }}>
              <img src="/icons/info.svg" alt="" />
              <p className={"info-tooltip position-absolute"} style={{ width: "200px" }}>
                This section allows you to convert {currentConfig.symbol} into {currentConfig.xSymbol}.
                Ensure your wallet is connected and has a sufficient balance
              </p>
            </div>
          </div>

          <form action="javascript:void(0);">
            <div className={style.select_card + " position-relative"}>
              <div className='d-flex gap-3 align-items-center'>
                <div className='d-flex align-items-center gap-2 position-relative'>
                  <div className={style.imgdiv + ' d-flex justify-content-center align-items-center'}>
                    <img src={currentConfig.icon} alt={currentConfig.symbol} />
                  </div>

                  <div className="position-relative">
                    <button
                      type="button"
                      className={`${style.tokenSelector} border-0 bg-transparent opacity-100 fs-6 mb-0  d-flex align-items-center`}
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowTokenDropdown(!showTokenDropdown);
                      }}
                    >
                      {currentConfig.symbol}
                      {/* <img
                        src="/icons/arrow-down.png"
                        alt="dropdown"
                        className={`ms-2 ${showTokenDropdown ? style.rotate180 : ''}`}
                        style={{ width: '12px', transition: 'transform 0.3s' }}
                      /> */}
                      <svg className={`ms-4 ${showTokenDropdown ? "" : style.rotate180}`}
                        width="12" height="8" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.93359 9.75756L8.74201 2.44482L14.9092 9.75757" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                    </button>

                    {showTokenDropdown && (
                      <div className={style.tokenDropdown} onClick={(e) => e.stopPropagation()}>
                        {Object.entries(TOKEN_CONFIG).map(([key, config]) => (
                          <button
                            key={key}
                            type="button"
                            className={`${style.tokenOption} ${selectedToken === key ? style.active : ''}`}
                            onClick={() => handleTokenSelect(key)}
                          >
                            <img src={config.icon} alt={config.symbol} width="20" className="me-2" />
                            {config.symbol}
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                </div>

                <p className='mb-0 flex-grow-1'>
                  <input
                    className={`${style.outline_none} w-100 border-0 bg-transparent fs-3 w-fit-content`}
                    type="number"
                    placeholder="0.00"
                    value={alienInputValue}
                    onChange={(e) => stackhandleAlienInputChange(e, parseInt?.(poolInfo?.[2]) / 10e3)}
                  />
                </p>
              </div>
              <button className={style.metaBtn + " btn3 py-1 position-absolute "}
                                   onClick={() =>
                                    addTokenInMetaMask(
                                      currentConfig.symbol,
                                      currentConfig.tokenAddress,
                                      ""
                                    )
                                  }
              >
                <AddIcon />
                <img class="ms-2" src="/icons/metamask.svg" alt=""></img>
              </button>

              <div className='d-flex mt-2 justify-content-between'>
                <p className='mb-0 btn border-0 bg-transparent'
                  onClick={() => {
                    setMax(
                      alienBalance?.formatted
                        ? parseFloat?.(alienBalance?.formatted).toFixed(6)
                        : "0.0",
                      parseInt?.(poolInfo?.[2]) / 10e3
                    );
                  }}>Max</p>
                <p className='mb-0'>
                  <span className='me-2'>Balance</span>
                  {alienBalance?.formatted
                    ? parseFloat?.(alienBalance?.formatted).toFixed(5)
                    : "0.00"}
                </p>
              </div>
            </div>

            <div className={style.arrowdiv + " my-4 d-flex justify-content-center"}>
              <button type="button" className='d-flex justify-content-center align-items-center'>
                <img src="/icons/arrow-down.png" alt="" />
              </button>
            </div>

            <div className={style.select_card + " position-relative"}>
              <div className='d-flex align-items-center gap-3'>
                <div className='d-flex align-items-center gap-2'>
                  <div className={style.imgdiv + ' d-flex justify-content-center align-items-center'}>
                    <img src={currentConfig.icon} alt={currentConfig.xSymbol} />
                  </div>
                  <p className="opacity-100 fs-6 mb-0 "
                    style={{ padding: "0 12px", lineHeight: "20px" }}
                  >{currentConfig.xSymbol}</p>
                </div>
                <p className='mb-0 flex-grow-1'>
                  <input
                    className={`${style.outline_none} w-100 border-0 bg-transparent fs-3 w-fit-content`}
                    type="number"
                    placeholder="0.00"
                    value={alienXInputValue === 0 ? "0.0" : parseFloat(alienXInputValue)?.toFixed(4)}
                    readOnly
                  />
                </p>
              </div>
              <div className='d-flex mt-2 justify-content-between'>
                <p className='mb-0'></p>
                <p className='mb-0'>
                  <span className='me-2'>Balance</span>
                  {alienXBalance?.formatted
                    ? parseFloat?.(alienXBalance?.formatted).toFixed(5)
                    : "0.0"}
                </p>
              </div>
              <button className={style.metaBtn + " btn3 py-1 position-absolute "}
                  onClick={() =>
                    addTokenInMetaMask(
                      xTokenInfo.symbol,
                      xTokenAddress,
                      ""
                    )
                  }
              >
                <AddIcon />
                <img class="ms-2" src="/icons/metamask.svg" alt=""></img>
              </button>
            </div>

            <div className={style.balancediv + " mt-3 mb-5"}>
              <div className='d-flex my-1 justify-content-between'>
                <span>Mint fee</span>
                <p className="text-end">
                  {parseInt?.(poolInfo?.[2]) > 0
                    ? parseInt?.(poolInfo?.[2]) / 10e3
                    : 0}%
                </p>
              </div>
              <div className='d-flex my-1 justify-content-between'>
                <span>Minimum Received</span>
                <p className="text-end">
                  {alienInputValue === ""
                    ? "0.0"
                    : (parseFloat?.(alienXInputValue) - parseFloat?.(alienXInputValue) * (SlippageInPercent / 100)).toFixed(4)}{" "}
                  {currentConfig.xSymbol}
                </p>
              </div>
              <div className='d-flex my-1 justify-content-between'>
                <span>Slippage</span>
                <div className='d-flex gap-2'>
                  <button className={"btn2"} onClick={() => setSlippageInPercent(0.5)}>0.5%</button>
                  <button className={"btn2"} onClick={() => setSlippageInPercent(1)}>1%</button>
                  <button className={"btn2"} onClick={() => setSlippageInPercent(2)}>2%</button>
                  <input
                    className="btn2"
                    value={SlippageInPercent + "%"}
                    onChange={(e) => {
                      const numericValue = e.target.value.replace(/[^0-9.]/g, "");
                      setSlippageInPercent(numericValue);
                    }}
                  />
                </div>
              </div>
            </div>

            {address && isConnected ? (
              selectedToken !== 'BNB' && !isAproveERC20 ? (
                <div>
                  <ApproveButton
                    tokenAddress={currentConfig.tokenAddress}
                    spenderAddress={currentConfig.poolAddress}
                    setIsApprovedERC20={setIsApprovedERC20}
                    isLpToken={false}
                    color={"white"}
                  />
                </div>
              ) : parseFloat?.(alienInputValue) > parseFloat?.(alienBalance?.formatted) ? (
                <div className="bag-1">
                  <button className="btn1 py-3 w-100">
                    Insufficient Fund
                  </button>
                </div>
              ) : (
                <>
                  <button
                    disabled={parseFloat?.(alienInputValue) > 0 && !isLoadingMint ? false : true}
                    onClick={handleMint}
                    className="btn1 py-3 w-100"
                  >
                    {isLoadingMint ? <Loader color="#423A2A" /> : null}
                    Mint {currentConfig.xSymbol}
                  </button>

                  {parseFloat?.(userInfo?.[0]) > 0 && (
                    <button
                      disabled={
                        Number(userInfo?.[3]?.toString()) > Number(currentBlock) + 3 ||
                        (parseFloat?.(userInfo?.[0]) > 0 && !isLoadingCollect ? false : true)
                      }
                      onClick={executeWriteCollect}
                      className="btn1 py-3 w-100"
                    >
                      {isLoadingCollect ? <Loader color="#423A2A" /> : null}
                      Collect{" "}
                      {parseFloat?.(convertWeiToEther?.(userInfo?.[0]?.toString())).toFixed(6)}{" "}
                      {currentConfig.xSymbol}
                    </button>
                  )}
                </>
              )
            ) : (
              <button
                onClick={openConnectModal}
                className="btn1 py-3 w-100"
              >
                Connect Wallet
              </button>
            )}
          </form>
        </div>
      </div>
      <NewFooter />
    </main>
  );
};

export default Mint;